module.exports = __webpack_public_path__ + "static/media/vascularization-Figure4.e14a72ef.jpg";